var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"bigTitle"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }